import React, { useState, ChangeEvent, useEffect } from "react";
// import {
//   addTeamMember,
//   deleteTeamMember,
//   deleteTeamMembers,
//   getAllInvites,
//   TeamMember,
//   getTeamMembers,
// } from "@redux/slices/invite";
import { useNavigate } from "react-router";
import { Button } from "@components/ui/button";
import { IoAdd } from "react-icons/io5";
import { FiTrash2 } from "react-icons/fi";
import LoadingScreen from "@components/LoadingScreen";
import Table from "@components/Table";
import { Checkbox, IconButton } from "@mui/material";
import Iconify from "@components/iconify";
import ReactPaginate from "react-paginate";
import { enqueueSnackbar } from "notistack";
import useAuth from "@hooks/useAuth";
import { useSelector } from "react-redux";
import { RootState } from "@redux/store";
import {
  deleteTeamMember,
  deleteTeamMembers,
  getAllInvites,
  getInvites,
} from "@redux/slices/invite";
import { ChevronLeft } from "lucide-react";

interface TableData {
  id: string;
  email: string;
  //   invited_at: string;
  //   invited_by: string;
}

const TeamMembers: React.FC = () => {
  const [selected, setSelected] = useState<string[]>([]);
  const [itemOffset, setItemOffset] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [teamMembers, setTeamMembers] = useState<TableData[]>([]);
  const [searchQuery, setSearchQuery] = useState<string>("");

  const navigate = useNavigate();
  const { user } = useAuth();
  const selectedUserId = useSelector(
    (state: RootState) => state.user.selectedUserId
  );

  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  const getData = async () => {
    const data =
      user?.role !== "admin"
        ? await getAllInvites(user.id) // Fetching team members specific to the logged-in user
        : selectedUserId !== null
        ? await getAllInvites(selectedUserId)
        : await getInvites();

        if (data) {
          const validData = data.filter((member): member is TableData & { id: string } => member.id !== undefined);
          setTeamMembers(validData);
        } else {
          setTeamMembers([]);
        }

    setLoading(false);
  };

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  // Apply search filter
  const searchFilteredData = teamMembers.filter(
    (member) => member.email.toLowerCase().includes(searchQuery.toLowerCase())
    //   member.invited_by.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Pagination logic
  const endOffset = itemOffset + 5;
  const filteredData = searchFilteredData?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(searchFilteredData?.length / 5);

  const handlePageClick = (event: { selected: number }) => {
    const newOffset = (event.selected * 5) % searchFilteredData?.length;
    setItemOffset(newOffset);
  };

  const handleSelectAllClick = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = teamMembers?.map((n) => n.id);
      setSelected(newSelecteds);
    } else {
      setSelected([]);
    }
  };

  const handleClick = (name: string) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  return (
    <div>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div>
          <div className="md:flex items-center justify-between mt-7 ">
          <h4 className="text-xl font-bold flex items-center -ms-2 mb-5">
            <ChevronLeft
              size={22}
              className="me-3 cursor-pointer"
              onClick={() => navigate(-1)}
            />
            Invited Team Members
          </h4>
            <div className="md:mb-0 mb-4">
              <div className="relative">
                <input
                  className="appearance-none placeholder:text-[#B5B7C0] placeholder:text-sm placeholder:ps-1 border-0 pl-10 border-[#e2e8f0] bg-white shadow-sm transition-colors rounded-md w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none"
                  id="search"
                  type="text"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
                <div className="absolute left-0 inset-y-0 flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 ml-3 text-gray-400 hover:text-gray-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#71717A"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
              </div>
            </div>
            {/* <div className="sm:flex items-center">
              <div className="sm:mb-0 mb-4 flex items-center">
                {user?.role !== "admin" && (
                  <Button onClick={() => navigate("/team/addMember")}>
                    <IoAdd size={20} className="me-2" />
                    Invited Member
                  </Button>
                )}
              </div>
            </div> */}
          </div>
          {selected.length > 0 && (
            <div className="bg-gray flex justify-between rounded-t-lg px-5 py-2 items-center mt-5 text-white">
              <p>{selected?.length} selected</p>
              <IconButton
                className="text-white"
                onClick={async () => {
                  setLoading(true);
                  await deleteTeamMembers(selected);
                  getData();
                  setSelected([]);
                }}
              >
                <FiTrash2 color="white" />
              </IconButton>
            </div>
          )}
          <Table
            checkbox={user?.role !== "admin" && true}
            textIndex={3}
            tableHead={[
              { name: "Email" },
              //   { id: "invited_at", label: "Invited At" },
              //   { id: "invited_by", label: "Invited By" },
              { name: "" },
            ]}
            handleSelectAllClick={handleSelectAllClick}
          >
            {filteredData?.map((val, index) => (
              <tr
                key={index}
                className="text-sm text-gray text-center border-b last:border-0 border-[#EAECF0]"
              >
                {user?.role !== "admin" && (
                  <td>
                    <Checkbox
                      disableRipple
                      checked={selected.indexOf(val.id) !== -1}
                      onChange={() => handleClick(val.id)}
                    />
                  </td>
                )}
                <td className="p-5 text-left">{val.email}</td>
                {/* <td className="p-5 text-left">
                  {val.invited_at.split("T")[0]}
                </td>
                <td className="p-5 text-left text-lime-700 font-medium">
                  {val.invited_by}
                </td> */}
                {user?.role !== "admin" && (
                  <td>
                    <IconButton
                      className="text-gray"
                      onClick={async () => {
                        setLoading(true);
                        await deleteTeamMember(val?.id);
                        getData();
                      }}
                    >
                      <Iconify icon="eva:trash-2-outline" />
                    </IconButton>
                  </td>
                )}
              </tr>
            ))}
          </Table>
          <div className="flex flex-col md:flex-row justify-end items-center mt-8 pb-32">
            <div className="pagination">
              <ReactPaginate
                breakLabel="..."
                nextLabel={window.innerWidth > 576 ? "Next  →" : ">"}
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                previousLabel={window.innerWidth > 576 ? "← Previous" : "<"}
                renderOnZeroPageCount={() => null}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeamMembers;
